export default __webpack_public_path__ + "static/769-353252a2fbaf610a56af4724f7f391b6.gif";